const getSelectedData = (selectedRows, displayData) => {
    const filter = displayData.filter(({id}) => selectedRows === id)
    return filter ? filter[0] : null
}

module.exports = {
    getSelectedData,
}